import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="contact-info">
            <p className="contact-email">
              Contact: <a href="mailto:info@verynews.org">info@verynews.org</a>
            </p>
          </div>
          <p className="copyright">
            © {currentYear} VeryNews. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

